const COMPANY_DEFAULT_FIELDS = [
  'company_name',
  'reg_number',
  'nature',
];

const COMPANY_ADDRESS_FIELDS = [
  'street',
  'address',
  'city',
  'country',
  'zip'
];

const addPrefix = (prefix) => (key) => [prefix, key].join('_');

const COMPANY_REGISTER_FIELDS = COMPANY_ADDRESS_FIELDS.map(addPrefix('register'));
const COMPANY_OPERATING_FIELDS = COMPANY_ADDRESS_FIELDS.map(addPrefix('operating'));

const getDefaultCompanyData = (props) => (
  [...COMPANY_DEFAULT_FIELDS, ...COMPANY_REGISTER_FIELDS].reduce((acc, key) => {
    acc[key] = props[key] || '';
    return acc;
  }, {})
)

module.exports = {
  COMPANY_DEFAULT_FIELDS,
  COMPANY_ADDRESS_FIELDS,

  COMPANY_REGISTER_FIELDS,
  COMPANY_OPERATING_FIELDS,

  getDefaultCompanyData
}
